module.exports = __webpack_public_path__ + "static/media/pending.f96501a9.svg";